import $ from 'jquery';

$('.quote__more-link').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.quote').toggleClass('quote--expanded');
});
